import { ListGroupItem } from "reactstrap";
import SpinnerIcon from "../SpinnerIcon";
import { BLUE_TICK } from "../../constants/colors";
import { setLocalStorageValue } from "../../utils/useLocalStorage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../app/store";
import { isIncludeCommittedLoadQuotationSentEnabled } from "../../app/settingsSlice";
import Feature from "../feature-flag/Feature";

const CommittedLoadIncludeQuotationSentSetting = () => {
  const dispatch = useDispatch();
  const includeCommittedLoadQuotationSent = useSelector(
    (state: RootState) => state.settings.isIncludeCommittedLoadQuotationSentEnabled,
  );

  return (
    <Feature flag="UseAcceptToConnectDataEnabled">
      <ListGroupItem
        tag="a"
        action
        className="d-flex justify-content-between align-items-center text-light"
        onClick={() => {
          dispatch(isIncludeCommittedLoadQuotationSentEnabled());
          setLocalStorageValue(
            "includeCommittedLoadQuotationSent",
            !includeCommittedLoadQuotationSent,
          );
        }}
      >
        <span className="mr-4">Include Committed Load Quotation Sent</span>
        <SpinnerIcon
          flag={includeCommittedLoadQuotationSent}
          showSpinner={false}
          color={BLUE_TICK}
        />
      </ListGroupItem>
    </Feature>
  );
};

export default CommittedLoadIncludeQuotationSentSetting;
